// @flow
import * as React from "react";
import { withFetch } from "./common/fetch";
import Tournament from "./Tournaments/Api";

type Props = {
  // название из campaigns или свой объект
  campaign: "80_percent_user" | "operation_early_close",
  children: (show: boolean) => React.Node | React.Node
};

const ABTest = ({ campaign, ...props }: Props) => {
  const features = props.api.readEntity("/api/features/list");

  const show = () => {
    if (process.env.REACT_APP_DEPLOY_TARGET !== "irontrade") {
      return false;
    }

    if (campaign != null) {
      const currentCampaign =
        features.value &&
        features.value.find(feature => feature.name === campaign);

      // если кампания активна, то показываем деток
      if (currentCampaign) {
        return true;
      }

      return false;
    }

    // если кампания не указана, то тоже показываем деток
    return true;
  };

  if (typeof props.children === "function") {
    return props.children(show);
  }

  if (show === false) {
    return null;
  }

  return props.children;
};

export default withFetch(props => (
  <Tournament.Consumer>
    {api => <ABTest {...props} api={api} />}
  </Tournament.Consumer>
));



// WEBPACK FOOTER //
// ./src/components/ABTest.js